import { render, staticRenderFns } from "./SuppliersLogin.vue?vue&type=template&id=1f9f64ee&scoped=true&"
import script from "./SuppliersLogin.vue?vue&type=script&lang=ts&"
export * from "./SuppliersLogin.vue?vue&type=script&lang=ts&"
import style0 from "./SuppliersLogin.vue?vue&type=style&index=0&id=1f9f64ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f9f64ee",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VContainer,VImg})
